export default __webpack_public_path__ + "static/media/promo-2.dcd41817.jpg";